import styled from "styled-components";
import { Button } from "@material-ui/core";

export const Container = styled.div`
  margin-bottom: 1.2rem;
`;

export const Content = styled.div``;

export const Title = styled.p`
  margin: 0;
  font-weight: bold;
  text-transform: uppercase;
`;

export const InfoContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const ButtonContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
`;

export const Information = styled.ul`
  list-style-type: none;
  padding: 0;
  margin-bottom: 0;
  padding-left: 10px;

  & > * {
    display: flex;
  }

  .icon {
    padding-right: 0.5rem;
  }

  &:hover {
    cursor: pointer;
  }
`;

export const MoneyIcon = styled.li``;

export const ChainIcon = styled.li``;

export const Anchor = styled.a`
  white-space: nowrap;
  width: 240px;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const LiveTvIcon = styled.li``;

export const DeleteBtn = styled(Button)`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
`;
